"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadAnswers = exports.saveAnswer = exports.getLanguages = exports.getAnswers = exports.deleteAnswerRequest = exports.deleteAnswer = exports.createAnswer = exports.UPLOAD_ANSWER_SUCCESS = exports.UPLOAD_ANSWER_REQUEST = exports.UPLOAD_ANSWER_FAILURE = exports.SAVE_ANSWER_SUCCESS = exports.SAVE_ANSWER_REQUEST = exports.SAVE_ANSWER_FAILURE = exports.GET_LANGUAGES_SUCCESS = exports.GET_LANGUAGES_REQUEST = exports.GET_LANGUAGES_FAILURE = exports.GET_ANSWERS_SUCCESS = exports.GET_ANSWERS_REQUEST = exports.GET_ANSWERS_FAILURE = exports.DELETE_ANSWER_SUCCESS = exports.DELETE_ANSWER_REQUEST = exports.DELETE_ANSWER_FAILURE = exports.CREATE_ANSWER_SUCCESS = exports.CREATE_ANSWER_REQUEST = exports.CREATE_ANSWER_FAILURE = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("../middleware/api");
var GET_ANSWERS_REQUEST = exports.GET_ANSWERS_REQUEST = 'GET_ANSWERS_REQUEST';
var GET_ANSWERS_SUCCESS = exports.GET_ANSWERS_SUCCESS = 'GET_ANSWERS_SUCCESS';
var GET_ANSWERS_FAILURE = exports.GET_ANSWERS_FAILURE = 'GET_ANSWERS_FAILURE';
var CREATE_ANSWER_REQUEST = exports.CREATE_ANSWER_REQUEST = 'CREATE_ANSWER_REQUEST';
var CREATE_ANSWER_SUCCESS = exports.CREATE_ANSWER_SUCCESS = 'CREATE_ANSWER_SUCCESS';
var CREATE_ANSWER_FAILURE = exports.CREATE_ANSWER_FAILURE = 'CREATE_ANSWER_FAILURE';
var SAVE_ANSWER_REQUEST = exports.SAVE_ANSWER_REQUEST = 'SAVE_ANSWER_REQUEST';
var SAVE_ANSWER_SUCCESS = exports.SAVE_ANSWER_SUCCESS = 'SAVE_ANSWER_SUCCESS';
var SAVE_ANSWER_FAILURE = exports.SAVE_ANSWER_FAILURE = 'SAVE_ANSWER_FAILURE';
var DELETE_ANSWER_REQUEST = exports.DELETE_ANSWER_REQUEST = 'DELETE_ANSWER_REQUEST';
var DELETE_ANSWER_SUCCESS = exports.DELETE_ANSWER_SUCCESS = 'DELETE_ANSWER_SUCCESS';
var DELETE_ANSWER_FAILURE = exports.DELETE_ANSWER_FAILURE = 'DELETE_ANSWER_FAILURE';
var UPLOAD_ANSWER_REQUEST = exports.UPLOAD_ANSWER_REQUEST = 'UPLOAD_ANSWER_REQUEST';
var UPLOAD_ANSWER_SUCCESS = exports.UPLOAD_ANSWER_SUCCESS = 'UPLOAD_ANSWER_SUCCESS';
var UPLOAD_ANSWER_FAILURE = exports.UPLOAD_ANSWER_FAILURE = 'UPLOAD_ANSWER_FAILURE';
var GET_LANGUAGES_REQUEST = exports.GET_LANGUAGES_REQUEST = 'GET_LANGUAGES_REQUEST';
var GET_LANGUAGES_SUCCESS = exports.GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
var GET_LANGUAGES_FAILURE = exports.GET_LANGUAGES_FAILURE = 'GET_LANGUAGES_FAILURE';
var getLanguages = exports.getLanguages = function getLanguages() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_LANGUAGES_REQUEST, GET_LANGUAGES_SUCCESS, GET_LANGUAGES_FAILURE],
    authenticated: true,
    endpoint: "answers/languages",
    method: 'GET'
  });
};
var uploadAnswers = exports.uploadAnswers = function uploadAnswers(data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [UPLOAD_ANSWER_REQUEST, UPLOAD_ANSWER_SUCCESS, UPLOAD_ANSWER_FAILURE],
    authenticated: true,
    endpoint: "answers/upload",
    method: 'POST',
    payload: data
  });
};
var getAnswers = exports.getAnswers = function getAnswers() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_ANSWERS_REQUEST, GET_ANSWERS_SUCCESS, GET_ANSWERS_FAILURE],
    authenticated: true,
    endpoint: 'answers',
    method: 'GET'
  });
};
var createAnswer = exports.createAnswer = function createAnswer(data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [CREATE_ANSWER_REQUEST, CREATE_ANSWER_SUCCESS, CREATE_ANSWER_FAILURE],
    authenticated: true,
    endpoint: "answers",
    method: 'POST',
    payload: data
  });
};
var saveAnswer = exports.saveAnswer = function saveAnswer(answerID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SAVE_ANSWER_REQUEST, SAVE_ANSWER_SUCCESS, SAVE_ANSWER_FAILURE],
    authenticated: true,
    endpoint: "answers/".concat(answerID),
    method: 'PUT',
    payload: data
  });
};
var deleteAnswer = exports.deleteAnswer = function deleteAnswer(answerID) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return dispatch(deleteAnswerRequest(answerID));
          case 1:
            return _context.abrupt("return", dispatch(getAnswers()));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var deleteAnswerRequest = exports.deleteAnswerRequest = function deleteAnswerRequest(answerID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [DELETE_ANSWER_REQUEST, DELETE_ANSWER_SUCCESS, DELETE_ANSWER_FAILURE],
    authenticated: true,
    endpoint: "answers/".concat(answerID),
    method: 'DELETE'
  });
};